// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/**
 * A tuple of the supported ActionType values for CampaignStore, for use in the registry.
 * Note: The order of ActionTypes must remain consistent with the order defined in StoreActions.
 */ export const CampaignStoreActionTypes = [
    ActionType.CampaignTriggerAction,
    ActionType.DismissActiveCampaignCreative,
    ActionType.FetchCampaignCreatives,
    ActionType.FetchCampaignCreativesFailed,
    ActionType.FetchCampaignCreativesSucceeded,
    ActionType.IncrementSessionTaskCreationCount,
    ActionType.NavigateToView,
    ActionType.PushSubRoute,
    ActionType.ReplaceSubRoute,
    ActionType.SendCampaignCreativeImpressionBeacon,
    ActionType.ShowNextActiveCampaignCreativeStep
];
